export default {
	methods: 
    {	
		async searchDocumentos(value)
		{			
			// await this.getDataGet({route: 'get_afldocumentos' , data: 'documentos'})			
		},
		resetFile()
		{
		  this.uploadReady = false
		  this.$nextTick(() => {
				this.uploadReady = true
		  })		 
		},
		async inputSearchs()
		{
			this.searchsGet =  await this.getData({route: 'get_aflregistro', data:  this.searchSw.value })
		},
		async getFiltrar()
		{
			let dataRoute={}
			let others=[]
			let filterKeys= Object.keys(this.filter);
			for (let i = 0; i < filterKeys.length; i++) {				
				if(this.filter[filterKeys[i]]!==''  && this.filter[filterKeys[i]]!==null)
				{
					others.push([filterKeys[i],this.filter[filterKeys[i]] ])
				}	
			}
			dataRoute.others=others
			await this.getDataGet({ route: 'get_afldocumentos', data: dataRoute})
			// frontend await this.searchGetIdb({tabla:'get_afldocumentos', campo:'id_datos_afiliado', value: this.filter.id_datos_afiliado[0].id})
		},	
		async getLimpiar()
		{
			this.filter.id_datos_afiliado = null
			await this.getDataGet({ route: 'get_afldocumentos', data: {others: []}})
			// frontend await this.searchGetIdb({tabla:'get_afldocumentos', campo:'id_datos_afiliado', value: this.filter.id_datos_afiliado[0].id})
		}
	},
}